module.exports = __webpack_public_path__ + "static/media/0011.c1e0523e.jpg";